import React, { useState, useEffect } from "react";
import * as Styled from "./styled";
import Sidemenu from "../../components/sidemenu";
import Header from "../../components/header";
import { functionService } from "../../lib/functions";
import { Select, DatePicker, Button, Modal, Input, Tooltip } from "antd";
import moment from "moment";
import { useLocation } from "react-router-dom";
import ProfileComp from "../profileView/ProfileComp";
import Assessment from "../profileView/Assessment";
import ProjectWork from "../profileView/ProjectWork";
import ScreeningInterview from "../profileView/ScreeningInterview";

const CompanyListing = () => {
  const [jobListings, setJobListings] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [filteredJobListings, setFilteredJobListings] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false); // State for View Modal
  const [id, setId] = useState("");
  const [remarks, setRemarks] = useState("");
  const [modalData, setModalData] = useState({
    status: "",
  });
  const [viewData, setViewData] = useState(null); // State for View modal data
  

  const location = useLocation();

  const getCompanyFirstPage = async () => {
    const { role } = location.state || {};
    const email = localStorage.getItem("userEmail");
    const obj = { email, role };

    try {
      const secondPageDetails = await functionService.getCompanyListings(obj);
      if (secondPageDetails.status) {
        const jsonData = secondPageDetails.response.data.data;
        setId(jsonData[0].candidate_id);
        setJobListings(jsonData);
      } else {
        console.error("Error fetching details:", secondPageDetails.error);
      }
    } catch (error) {
      console.error("Error in fetch Details:", error);
    }
  };

  useEffect(() => {
    getCompanyFirstPage();
  }, []);

  useEffect(() => {
    setFilteredJobListings(jobListings);
  }, [jobListings]);

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsViewModalVisible(false); // Close View modal too
  };

  const handleOk = async () => {
    const obj = {
      id: id,
      remarks: remarks,
      status: modalData.status,
    };

    try {
      const updateRemarks = await functionService.setCandidateRemarks(obj);
      if (updateRemarks.status) {
        console.log(updateRemarks.response.data.data);
      } else {
        console.error("Error updating details:", updateRemarks.error);
      }
    } catch (error) {
      console.error("Error in update Details:", error);
    }
    console.log("My overall status is------->", modalData.status);
    setRemarks("");
    setIsModalVisible(false);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedListings = filteredJobListings.slice(
    startIndex,
    startIndex + itemsPerPage
  );
  const totalPages = Math.ceil(filteredJobListings.length / itemsPerPage);

  const handleIconClick = (data, viewItem) => {
    setModalData({
      status: data,
    });
    if (data === "View") {
      setViewData(viewItem); // Store the view data to be shown in modal
      setIsViewModalVisible(true); // Show View modal
    } else {
      setIsModalVisible(true); // Show Approval/Reject modal
    }
  };

  const profile = {
    name: `${viewData?.first_name} ${viewData?.last_name}`,
    contact: viewData?.primary_no,
    email: viewData?.email_candidate,
    exp: `${viewData?.experience/12} years ${viewData?.experience%12} month`,
    salary: viewData?.salary,
    score: 92,
    imageUrl:
      "https://media.istockphoto.com/id/513727339/photo/head-and-shoulders-mans-silhouette.jpg?s=612x612&w=0&k=20&c=aAVL1IT9GT4URtLjS98515G5e3Qc4c7Np2EvKXBywMQ=",
    cvUrl:viewData?.cv_url
  };
  // const assessments = [
  //   {
  //     title: "Back End Developer - Node.js",
  //     skill: "Node.js",
  //     duration: "1 Hr 30 Min",
  //     marks: "60",
  //     score: "45/60",
  //     videoSrc: "/path-to-nodejs-assessment-video.mp4",
  //     downloadLink: "#",
  //   },
  //   {
  //     title: "Front End Developer - React.js",
  //     skill: "React.js",
  //     duration: "1 Hr 30 Min",
  //     marks: "60",
  //     score: "48/60",
  //     videoSrc: "/path-to-reactjs-assessment-video.mp4",
  //   },
  // ];
  // const project = {
  //   title: "Design Calculator",
  //   skill: "React.js",
  //   duration: "1 Hr 30 Min",
  //   downloadLink: "#",
  // };
  // const interview = {
  //   title: "Node.js Screening Interview ",
  //   skill: "Node.js",
  //   duration: "1 Hr 30 Min",
  // };

  return (
    <Styled.MainDiv>
      <Sidemenu />
      <Header />
      <Styled.ContentWrapDiv>
        <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
          <Select
            showSearch
            placeholder="Company status"
            optionFilterProp="children"
            onChange={(value) => setSelectedCompany(value)}
            allowClear
            style={{ width: "200px" }}
          >
            {companyList.map((item) => (
              <Select.Option key={item.company_name} value={item.company_name}>
                {item.company_name}
              </Select.Option>
            ))}
          </Select>
          <DatePicker
            placeholder="Select date"
            onChange={(date) =>
              setSelectedDate(date ? date.format("YYYY-MM-DD") : null)
            }
            style={{ width: "200px" }}
          />
        </div>
        <Styled.TableWrap>
          <Styled.MainTable>
            <thead>
              <tr>
                <th>Candidate Name</th>
                <th>Experience</th>
                <th>Salary</th>
                <th>Received On</th>
                <th>Approval status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedListings.map((item, index) => (
                <tr key={index}>
                  <td>{item.first_name} {item.last_name}</td>
                  <td>{item.experience}</td>
                  <td>{item.salary}</td>
                  <td>{new Date(item.received_on).toLocaleDateString()}</td>
                  <td>{item.approval_status}</td>
                  <td>
                    <Styled.IconDiv>
                      <Tooltip title="View">
                        <Styled.UpdateButton onClick={() => handleIconClick("View", item)} />
                      </Tooltip>
                      <Tooltip title="Approve">
                        <Styled.ViewButton onClick={() => handleIconClick("Approved")} />
                      </Tooltip>
                      <Tooltip title="Reject">
                        <Styled.OptionButton onClick={() => handleIconClick("Rejected")} />
                      </Tooltip>
                    </Styled.IconDiv>
                  </td>
                </tr>
              ))}
            </tbody>
          </Styled.MainTable>
        </Styled.TableWrap>

        <Styled.ParentContainer>
          <Styled.PaginationDiv>
            <button
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
              style={{ minWidth: "75px" }}
            >
              Previous
            </button>

            {currentPage > 3 && (
              <>
                <button onClick={() => setCurrentPage(1)}>1</button>
                <div className="ellipsis">...</div>
              </>
            )}

            {[...Array(totalPages)].map((_, i) => {
              const pageNumber = i + 1;

              if (
                pageNumber === currentPage ||
                (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
              ) {
                return (
                  <Styled.PaginationButton
                    key={i}
                    onClick={() => setCurrentPage(pageNumber)}
                    active={pageNumber === currentPage}
                  >
                    {pageNumber}
                  </Styled.PaginationButton>
                );
              }
              return null;
            })}

            {currentPage < totalPages - 2 && (
              <>
                <div className="ellipsis">...</div>
                <button onClick={() => setCurrentPage(totalPages)}>
                  {totalPages}
                </button>
              </>
            )}

            <button
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
              style={{ minWidth: "75px" }}
            >
              Next
            </button>
          </Styled.PaginationDiv>
        </Styled.ParentContainer>

        {/* View Modal */}
        <Modal
          visible={isViewModalVisible}
          onCancel={handleCancel}
          footer={[
            <Button key="back" onClick={handleCancel}>
              Close
            </Button>,
          ]}
        >
          {/* Add content to display specific data in View Modal */}
          <div>
            <ProfileComp profile={profile} />
            {/* <Styled.Heading>Assesment History-Live Recordings </Styled.Heading>
            <Styled.HeadingDescription>
              You will be able to view the complete recording of the candidate’s
              assessments. This way you can also check his approach to problem
              solving and not just depend on the final output.
            </Styled.HeadingDescription>
            {assessments.map((assessment, index) => (
              <Assessment key={index} assessments={assessment} />
            ))}
            <Styled.Heading>Project Work </Styled.Heading>
            <Styled.HeadingDescription>
              This section has the complete recording of candidate’s approach to
              the project work.
            </Styled.HeadingDescription>
            <ProjectWork project={project} />
            <Styled.Heading>Screening Interview </Styled.Heading>
            <Styled.HeadingDescription>
              Here you can see how the candidate answers some real interview
              questions. It will give you an insight into his communication
              skills, his ability to handle pressure and details of his past
              experiences. Makes the hiring decision real easy.{" "}
            </Styled.HeadingDescription>
            <ScreeningInterview interview={interview} /> */}
          </div>
        </Modal>

        {/* Approve/Reject Modal */}
        <Modal
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={[
            <Button key="back" onClick={handleCancel}>
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              style={{
                backgroundColor:
                  modalData.status === "Rejected" ? "red" : undefined,
                borderColor:
                  modalData.status === "Rejected" ? "red" : undefined,
              }}
              onClick={handleOk}
            >
              {modalData.status === "Rejected"
                ? "Reject Profile"
                : "Approve Profile"}
            </Button>,
          ]}
        >
          <Styled.FormDiv>
            <div>{modalData.status} Profile</div>
            <div>Remarks</div>

            <div style={{ display: "flex", flexDirection: "row", gap: "25px" }}>
              <Input.TextArea
                placeholder={
                  modalData.status === "Rejected"
                    ? "Enter the reason of the rejection or any other input"
                    : "Enter your remarks here, for e.g schedule the interview on X date"
                }
                style={{ width: "100%", height: "150px" }}
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </div>
          </Styled.FormDiv>
        </Modal>
      </Styled.ContentWrapDiv>
    </Styled.MainDiv>
  );
};

export default CompanyListing;
